import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Navbar from './components/Layout/Navbar';
import { useAuthStore } from './context/store';
import './index.css';

// Pages importées directement (pas de lazy pour éviter les erreurs)
import Home       from './pages/Home';
import Shop       from './pages/Shop';
import Product    from './pages/Product';
import Cart       from './pages/Cart';
import Checkout   from './pages/Checkout';
import Login      from './pages/Login';
import Register   from './pages/Register';
import Account    from './pages/Account';
import AdminDash  from './pages/admin/Dashboard';

function PrivateRoute({ children, adminOnly = false }) {
  const { isAuthenticated, isAdmin } = useAuthStore();
  if (!isAuthenticated) return <Navigate to="/connexion" replace />;
  if (adminOnly && !isAdmin()) return <Navigate to="/" replace />;
  return children;
}

function PageLoader() {
  return (
    <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ width: 40, height: 40, border: '2px solid #EAE3D6', borderTopColor: '#C9A84C', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/"              element={<Home />} />
        <Route path="/boutique"      element={<Shop />} />
        <Route path="/produit/:id"   element={<Product />} />
        <Route path="/panier"        element={<Cart />} />
        <Route path="/connexion"     element={<Login />} />
        <Route path="/inscription"   element={<Register />} />
        <Route path="/checkout"      element={<PrivateRoute><Checkout /></PrivateRoute>} />
        <Route path="/compte/*"      element={<PrivateRoute><Account /></PrivateRoute>} />
        <Route path="/admin/*"       element={<PrivateRoute adminOnly><AdminDash /></PrivateRoute>} />
        <Route path="*"              element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster
        position="bottom-right"
        toastOptions={{
          duration: 3500,
          style: {
            background: '#1C1A16',
            color: '#F5F0E8',
            fontFamily: 'DM Sans, sans-serif',
            fontSize: '14px',
            borderRadius: '8px',
            border: '1px solid #2E2C28',
          },
          success: { iconTheme: { primary: '#C9A84C', secondary: '#1C1A16' } },
          error:   { iconTheme: { primary: '#C0392B', secondary: '#fff' } }
        }}
      />
    </BrowserRouter>
  );
}
